import { render, staticRenderFns } from "./Task_Consult.vue?vue&type=template&id=8650b07c&scoped=true&"
import script from "./Task_Consult.vue?vue&type=script&lang=js&"
export * from "./Task_Consult.vue?vue&type=script&lang=js&"
import style0 from "./Task_Consult.vue?vue&type=style&index=0&id=8650b07c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8650b07c",
  null
  
)

export default component.exports